<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
        lg12>
        <material-card
          color="general"
          class="card-tabs"
        >
          <v-flex
            slot="header"
          >
            <v-tabs
              v-model="tab"
              color="transparent"
              slider-color="black"
            >

              <v-tab
                v-for="item in tabSlot"
                :key="item.tab"
              >
                {{ item.tab }}
              </v-tab>
            </v-tabs>
          </v-flex>

          <v-tabs-items v-model="tab" :touchless="true">
            <v-tab-item
              key="1"
            >
              <item-bundling-creation/>
            </v-tab-item>
            <v-tab-item
              key="2"
            >
              <quo-creation
                ref="quoCreationComponent" :key="quoCreationCounter"
                @eventQuoCreation="eventQuoCreation"/>
            </v-tab-item>
            <v-tab-item
              key="3">
              <quo-list
                ref="quoListComponent"
                @eventQuoList="eventQuoList"/>
            </v-tab-item>
          </v-tabs-items>
        </material-card>
      </v-flex>
      <v-dialog
        v-model="dialogDelete"
        max-width="400px">
        <v-card>
          <v-card-title class="headline">System Message Confirmation</v-card-title>
          <v-card-text>
            Are you sure want to remove this data? <br>
            "{{ deleteItemRecord.brand }} - {{ deleteItemRecord.materialNo }}"
          </v-card-text>
          <v-card-actions>
            <v-spacer/>

            <v-btn
              color="red darken-1"
              text
              flat
              @click="dialogDelete = false"
            >
              Cancel
            </v-btn>

            <v-btn
              color="green darken-1"
              text
              flat
              @click="deleteItem(deleteItemRecord)"
            >
              Ok
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-layout>
  </v-container>
</template>

<script>
  import displayFormatterMixins from '../../mixins/displayFormatterMixins'
  import ItemBundling from './md/ItemBundling'
  import ItemBundlingCreation from './quo/ItemBundlingCreation'
  import jsonCurrency from '../../i18n/Currencies.json'
  import QuoCreation from './quo/QuoCreation'
  import QuoList from './quo/QuoList'

  export default {
    name: 'Quotation',
    components: { QuoCreation, ItemBundling, ItemBundlingCreation, QuoList },
    mixins: [displayFormatterMixins],
    data: () => ({
      tab: null,
      tabSlot: [
        { key: 1, tab: 'Item Bundling', content: 'Tab 1 Content' },
        { key: 2, tab: 'Quotation Form', content: 'Tab 2 Content' },
        { key: 3, tab: 'Quotations List', content: 'Tab 3 Content' }

      ],
      currencyList: jsonCurrency,
      snack: false,
      valid: false,
      validApplyPrice: false,
      lazy: false,
      lazyApplyPrice: false,
      snackColor: '',
      snackText: '',
      checkAll: false,
      selected: [],
      rules: {
        requiredObj: obj => !!(Object.entries(obj).length !== 0) || 'Required.',
        required: value => !!value || 'Required.',
        max50chars: value => !value || value.length <= 50 || 'Max 50 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return !value || pattern.test(value) || 'Invalid e-mail.'
        },
        number: value => !isNaN(value) || 'Must be numeric'
      },
      pagination: { sortBy: 'brand' },
      dialog: false,
      dialogApplyPrice: false,
      dialogDelete: false,
      deleteItemRecord: {},
      quoCreationCounter: 0,
      editedIndex: -1,

      editedItem: {
        id: null,
        brand: '',
        materialNo: '',
        materialDesc: '',
        price: {
          suppPrice: '',
          sellingPrice: '',
          bottomPrice: ''
        },
        currency: '',
        category: '',
        isBundling: false
      },
      defaultItem: {
        id: null,
        brand: '',
        materialNo: '',
        materialDesc: '',
        price: {
          suppPrice: '',
          sellingPrice: '',
          bottomPrice: ''
        },
        currency: '',
        category: '',
        isBundling: false
      }
    }),
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      }
    },
    // called when page is created before dom
    created () {

    },

    methods: {
      eventQuoCreation (tabSelect) { // emitted from ChildComponent
        // setTimeout(() => {
        this.tab = tabSelect
        this.$refs.quoListComponent.getQuotationList()
        this.quoCreationCounter++ // to refresh @click.once in QuoCreation Form
        // }, 200)
      },
      eventQuoList (tabSelect) { // emitted from ChildComponent
        // setTimeout(() => {
        this.tab = tabSelect
        this.$refs.quoCreationComponent.editQuotHeader()
        // }, 200)
      },

      // object.assign fills in the empty object with the properties of item
      editItem (item, dbox = true) {
        this.editedIndex = this.DataList.indexOf(item)
        this.$store.commit('quo/setEditQuoRecord', item)
        this.editedItem = Object.assign({}, item)
        this.dialog = dbox
      },

      dialogDeleteShow (data) {
        this.dialogDelete = true
        this.deleteItemRecord = data
      },

      deleteItem (rec) {
        let endpoint = `api/item/${rec.id}`
        let method = 'delete'
        let s = {}
        this.DataList.splice(this.DataList.indexOf(rec), 1)
        this.$store.dispatch('updateTableItem', { endpoint, s, method })
          .then((response) => this.deleteInline())
          .catch(error => {
            console.log(error)
            this.cancelInline()
          })
        this.dialogDelete = false
      },

      close () {
        this.dialog = false
        this.dialogApplyPrice = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
          this.applyPriceItem = Object.assign({}, {
            priceRuleObj: {},
            idItems: [],
            sellingPrice: '',
            suppPrice: ''
          })
          this.selected = []
        }, 300)
      },

      save () {
        if (!this.$refs.form.validate()) {
          console.log('validation fail direct')
        }
        if (this.$refs.form.validate()) {
          console.log('validation success')
        }
        if (this.editedIndex > -1) {
          Object.assign(this.DataList[this.editedIndex], this.editedItem)
          let tableItem = this.editedItem
          let endpoint = `api/item/${this.editedItem.id}`
          let method = 'patch'
          this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
            .then((response) => this.saveInline())
            .catch(error => {
              console.log(error)
              this.cancelInline()
            })
        } else {
          let tableItem = this.editedItem
          this.DataList.push(this.editedItem)
          let endpoint = `api/item`
          let method = 'post'
          this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
            .then((response) => {
              this.getItems()
            })
            .catch(error => {
              console.log(error)
              this.cancelInline()
            })
        }
        this.close()
      },
      // toasts/snackbar messages for actions
      saveInline () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data saved/updated'
      },
      cancelInline () {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = 'Canceled'
      },
      deleteInline () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data removed'
      },
      reset () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data reset to default'
      },
      openInline () {
        this.snack = true
        this.snackColor = 'info'
        this.snackText = 'Dialog opened'
      },
      closeInline () {
        console.debug('Dialog closed')
      },
      checkboxSnack () {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = 'Please select at least one'
      }
    }
    // beforeRouteLeave (to, from, next) {
    //
    //   const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
    //   if (answer) {
    //     next()
    //   } else {
    //     next(false)
    //   }
    // },
  }
</script>

<style scoped>
  tbody tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, .05);
  }
</style>
